module.exports = __webpack_public_path__ + "img/pota-2.a74a433a.png";